import client from "../utils/client";

export const getCountries = (): Promise<DataList<Country>> =>
  client.get("/countries");
